import React from "react";
import { Money, money, riderCount, toAdminTone } from "./settlementParts";

export default function SalarySheetTotal({ totals }) {
  return (
    <tfoot>
      <tr>
        <td className="stl-sticky-start">
          <div className="stl-rider">
            <span className="stl-rider__name">Total</span>
            <span className="stl-rider__id">{riderCount(totals.riders)}</span>
          </div>
        </td>
        <td>{totals.orders}</td>
        <td className="stl-divide">
          <Money value={totals.deliveryCharges} />
        </td>
        <td>
          <Money value={totals.tips} />
        </td>
        <td>
          <Money value={totals.surge} />
        </td>
        <td className="stl-divide">
          <Money value={totals.incentive} />
        </td>
        <td>
          <Money value={totals.special} />
        </td>
        <td>
          <Money value={totals.correction} />
        </td>
        <td />
        <td className="stl-divide">
          <Money value={totals.cash} />
        </td>
        <td className={toAdminTone(totals.toAdmin)}>{money(totals.toAdmin)}</td>
        <td className="stl-divide">
          <Money value={totals.cashInHand} />
        </td>
        <td>
          <Money value={totals.chargesOwed} />
        </td>
        <td className="stl-sticky-end">
          <span className="stl-salary">{money(totals.salary)}</span>
        </td>
      </tr>
    </tfoot>
  );
}
